<div id="gh-dropdown" class="btn-group" dropdown container="body" [dropup]="dropUp" (isOpenChange)="onDropdownToggled($event)">
  <button id="gh-button" class="styleless-btn" dropdownToggle type="button" aria-controls="gh-dropdown-menu">
    <ng-content select="[gh-dropdown-toggle]"></ng-content>
  </button>
  <ul [ngClass]="dropdownMenuClass" id="gh-dropdown-menu" class="dropdown-menu" *dropdownMenu role="menu" aria-labelledby="gh-button">
    <li *ngFor="let item of menuItems" gh-dropdown-menu-item [item]="item" [class.gh-separator]="item.endOfSection" class="sp-p-8"></li>
  </ul>
</div>
